import axios from "../BaseUrl";

/** Key/value dashboard settings (container capacity, pricing inputs, ...). */
export const getSettings = async () => {
  try {
    const response = await axios.get("/dashboard/settings");
    return response;
  } catch (err) {
    return err.response;
  }
};
